var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5748 7.7168C16.5748 7.7168 16.0318 14.4518 15.7168 17.2888C15.7087 17.5877 15.6408 17.8819 15.5171 18.154C15.3934 18.4262 15.2164 18.6708 14.9966 18.8735C14.7768 19.0761 14.5187 19.2327 14.2374 19.3339C13.956 19.4351 13.6573 19.4789 13.3588 19.4628C10.7501 19.5095 8.14045 19.5095 5.52979 19.4628C5.23712 19.4728 4.94538 19.4246 4.67145 19.3211C4.39752 19.2176 4.14685 19.0607 3.93396 18.8596C3.72107 18.6586 3.55018 18.4173 3.4312 18.1497C3.31221 17.8821 3.24749 17.5936 3.24078 17.3008C2.92378 14.4388 2.38379 7.7218 2.38379 7.7218",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.958 4.48926H1",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6911 4.48898C14.3104 4.48879 13.9415 4.35681 13.6471 4.11545C13.3527 3.87409 13.1509 3.53824 13.0761 3.16498L12.8331 1.94901C12.7602 1.67668 12.5994 1.43603 12.3757 1.26443C12.152 1.09284 11.878 0.999882 11.5961 1H7.36307C7.08115 0.999882 6.80708 1.09284 6.5834 1.26443C6.35973 1.43603 6.19897 1.67668 6.12607 1.94901L5.88306 3.16498C5.80821 3.53824 5.60645 3.87409 5.31204 4.11545C5.01764 4.35681 4.64876 4.48879 4.26807 4.48898",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.ba14021b055556f185558dcf1fbea330.svg";
export { ForwardRef as ReactComponent };